import { jsx as r } from "react/jsx-runtime";
const i = ({ size: o = 20, color: e = "currentColor", ...n }) => /* @__PURE__ */ r("svg", { viewBox: "0 0 20 20", width: o, height: o, fill: "none", ...n, children: /* @__PURE__ */ r(
  "path",
  {
    d: "M13.5465 3.74731H19M19 3.74731L16.2732 1M19 3.74731L16.2732 6.49463M15.4716 12.6321L11.7286 13.3629C9.20001 12.0845 7.63849 10.6156 6.72957 8.32617L7.42944 4.54404L6.10696 1H2.69759C1.67233 1 0.86521 1.8535 1.01882 2.87458C1.40056 5.42318 2.52763 10.0451 5.82065 13.3629C9.27909 16.8474 14.2609 18.3594 17.0022 18.961C18.0611 19.1927 19 18.3612 19 17.2687V13.9866L15.4716 12.6321Z",
    stroke: e,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  i as PhoneIcon
};
